import type { SelectOption } from '@zen/DesignSystem/types';

export const packagingOptions: SelectOption<'Bags' | 'Cartons' | 'Packages'>[] = [
  {
    label: 'Bags',
    value: 'Bags'
  },
  {
    label: 'Cartons',
    value: 'Cartons'
  },
  {
    label: 'Packages',
    value: 'Packages'
  }
];
